import { createActions, createReducer } from 'reduxsauce'

import ItensLicitacaoService from '../../servicos/ItensLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaItensLicitacaoInicio: [],
    buscaItensLicitacaoSucesso: ['itensLicitacao'],
    buscaItensLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaItensLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaItensLicitacaoInicio())
        let serv = new ItensLicitacaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaItensLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaItensLicitacaoErro(error)))
    }
}

const buscaItensLicitacaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaItensLicitacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaItensLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.itensLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ITENS_LICITACAO_INICIO]: buscaItensLicitacaoInicio,
    [Types.BUSCA_ITENS_LICITACAO_ERRO]: buscaItensLicitacaoErro,
    [Types.BUSCA_ITENS_LICITACAO_SUCESSO]: buscaItensLicitacaoSucesso,
})
